import "./styles.scss";

import React from "react";
import clsx from "clsx";
import Pill from "components/Pill";
import { usePosts } from "context/posts";

const CategoriesContent = ({
  title,
  variant,
  selected = { slug: "show_all" },
}) => {
  const { categories } = usePosts();

  let formatted_categories = [
    {
      name: "Pokaż wszystkie wpisy",
      href: "/blog/",
      color: "purple",
      slug: "show_all",
    },
    {
      name: "Darmowe testy i quizy",
      href: "/quizy/",
      color: "blue",
      slug: "show_all",
    },
    ...categories?.map((item) => ({
      name: item?.name,
      slug: item?.slug,
      href: `/blog/${item?.slug}/`,
    })),
  ];

  return (
    <div
      className={clsx(
        "categories-content",
        variant && `categories-content--${variant}`
      )}
    >
      <p className="categories-content__title">{title}</p>
      <div className="categories-content__content">
        {formatted_categories?.map((item, index) => (
          <Pill
            key={index}
            label={item?.name}
            href={item?.href}
            variant={item?.color || "orange"}
            selected={selected?.slug === item?.slug}
          />
        ))}
      </div>
    </div>
  );
};

export default CategoriesContent;
